import React, {Component} from 'react';

import {dt, getCode} from 'l10n';

export default function CountrySelect(props) {
    let localeCode = getCode();

    let {name, onChange, defaultValue, value, countries} = props;

    return (
        <select name={name} onChange={onChange} value={value} defaultValue={defaultValue}>
            <option value="">{dt('location_select', 'All')}</option>
            {countries && countries.length && countries.map((country) => <option value={country.code} key={country.code}>{country[localeCode]}</option>)}
        </select>
    )
}


// WEBPACK FOOTER //
// ./src/components/common/CountrySelect.js